import { useState, useRef, useCallback } from 'react';
import { ISpeechRecognition } from '@/types/speechRecognition';

export const useSpeechRecognitionState = () => {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState('');
  const recognitionRef = useRef<ISpeechRecognition | null>(null);
  const finalTranscriptTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const cleanup = useCallback(() => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      recognitionRef.current = null;
    }
    if (finalTranscriptTimeoutRef.current) {
      clearTimeout(finalTranscriptTimeoutRef.current);
      finalTranscriptTimeoutRef.current = null;
    }
    setIsListening(false);
  }, []);

  return {
    isListening,
    setIsListening,
    transcript,
    setTranscript,
    recognitionRef,
    finalTranscriptTimeoutRef,
    cleanup
  };
};